import IconChevronDown from '@apollo/icons/default/IconChevronDown.svg';
import React, { useState } from 'react';

import { format } from 'src/lib/format';

import { ErrorSummaryBucket } from '../bucketSummariesByErrorMessage';
import { ErrorInstance } from '../errorInstance/ErrorInstance';

const msgLen = 250;

export const ErroredTraceItem = ({
  errorMessage,
  summaries,
  httpStatuses,
}: ErrorSummaryBucket) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const groupStatus = httpStatuses.every((s) => s === httpStatuses[0])
    ? httpStatuses[0]
    : null;
  const httpMsg =
    groupStatus && groupStatus !== 200
      ? `HTTP status code ${groupStatus}: `
      : '';

  return (
    <div className="mb-4">
      <div>
        {errorMessage && errorMessage.length > msgLen ? (
          <span className="text-code break-all">
            {httpMsg}
            {errorMessage.slice(0, msgLen).concat('...')}
          </span>
        ) : (
          <span className="text-code break-all">
            {httpMsg}
            {errorMessage || 'Reported error contained no message'}
          </span>
        )}
      </div>
      <div className="mb-2 mt-4 cursor-pointer rounded text-sm font-semibold hover:bg-primary">
        <div
          className="flex items-center"
          onClick={() => {
            setIsExpanded(!isExpanded);
          }}
        >
          <IconChevronDown
            className="mx-2 text-secondary"
            style={{ transform: isExpanded ? 'none' : 'rotate(-90deg)' }}
          />{' '}
          {`${summaries.length} ${format.pluralize(
            summaries.length,
            'instance',
          )} of this error`}
        </div>
        {isExpanded && (
          <div className="mx-4 pb-2">
            <div className="mt-2 flex pb-1 text-xs uppercase tracking-wider">
              <div className="ml-2 flex-2">Time</div>
              <div className="flex-4">Operation</div>
              <div className="flex-1">Trace</div>
            </div>
            {summaries.map((summary) => (
              <ErrorInstance key={`summary-${summary.traceId}`} {...summary} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
